
export const SET_MSG = 'TABELAPRECORUBLICA_MSG';
export const SET_EDITAR = 'TABELAPRECORUBLICA_EDITAR';
export const SET_LISTA = 'TABELAPRECORUBLICA_LISTA';
export const SET_PESQUISA = 'TABELAPRECORUBLICA_PESQUISA';
export const SET_EVENTO = 'TABELAPRECORUBLICA_EVENTO';
export const SET_LISTAEVENTO = 'TABELAPRECORUBLICA_LISTAEVENTO';
export const SET_CODIGO = 'TABELAPRECORUBLICA_CODIGO';